import Site from '../portal/asteroid/site'

let site = new Site()

export default site